export default state => state.category.details?.featuredHeader || false;
